import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prefer-stateless-function
export default class MatchedPairReport extends React.Component {
  static propTypes = {
    matchedPairReportData: PropTypes.object.isRequired,
  };

  render() {
    const reportData = this.props.matchedPairReportData;
    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">Matched Pairs Export</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-8">
              <div className="card-border">
                <div className="card-header">
                  { reportData.status === 'COMPLETED' ?
                    <div className="card-header-title">
                      <a href={reportData.csvUrl} target="_blank" rel="noopener noreferrer">Download Matched Pairs CSV</a>
                    </div> :
                    <div className="card-header-title">Processing... Please wait.</div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
